<div class="flex items-center justify-center h-full">
  <form
    [formGroup]="resetPasswordForm"
    (ngSubmit)="onSubmit()"
    class="bg-white px-4 py-8 sm:p-8 shadow-md rounded-lg w-full max-w-[420px]"
  >
    <div class="logo-bar">
      <img src="assets/maxbrain-logo.svg" alt="MaxBrain" />
    </div>

    <div class="flex items-center justify-between mb-6">
      <ng-icon
        name="heroArrowLeftSolid"
        class="w-8 h-8"
        color="black"
        size="24px"
        class="cursor-pointer"
        routerLink="/"
      />
      <h2
        class="font-bold text-[28px] leading-8 tracking-normal text-center flex-grow text-[var(--color-darkgraytextcolor)]"
      >
        Reset password
      </h2>
    </div>

    <!-- Email Field -->
    <div class="mb-6">
      <label
        for="email"
        class="font-normal text-sm leading-5 tracking-normal text-[var(--color-darkgraytextcolor)]"
        >Email</label
      >
      <input
        id="email"
        type="email"
        formControlName="email"
        class="w-full p-2 border rounded mt-2 h-[52px] focus:ring-0 focus:outline-none"
        [ngClass]="{
          'border-[#E0E0E0]':
            resetPasswordForm.get('email')?.valid ||
            resetPasswordForm.get('email')?.untouched,
          'border-red-500':
            resetPasswordForm.get('email')?.invalid &&
            resetPasswordForm.get('email')?.touched
        }"
      />
      <div
        class="text-red-500 text-sm mt-1"
        *ngIf="
          resetPasswordForm.get('email')?.invalid &&
          resetPasswordForm.get('email')?.touched
        "
      >
        <small *ngIf="resetPasswordForm.get('email')?.errors?.['required']"
          >Email is required.</small
        >
        <small *ngIf="resetPasswordForm.get('email')?.errors?.['email']"
          >Invalid email format.</small
        >
      </div>
    </div>

    <button
      type="submit"
      [disabled]="resetPasswordForm.invalid"
      class="w-full bg-[var(--color-primary-600)] cursor-pointer disabled:cursor-not-allowed text-white font-medium py-2 rounded mt-4 disabled:opacity-25 h-[48px]"
    >
      Send reset code
    </button>
  </form>
</div>
